if (!customElements.get("m-product-tabs")) {
  class MProductTabs extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"],
      };

      this.tabSliders = new Map();
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.paginationType = this.dataset.paginationType || "progressbar";
      this.items = parseInt(this.dataset.items, 10) || 4;
      this.mobileItems = parseFloat(this.dataset.mobileItems) || 2;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderEnabled) {
        for (const block of this.domNodes.tabContent) {
          this.initSliderByScreenSize(block);
        }

        document.addEventListener("matchMobile", () => {
          for (const block of this.domNodes.tabContent) {
            this.initSliderByScreenSize(block);
          }
        });

        document.addEventListener("unmatchMobile", () => {
          for (const block of this.domNodes.tabContent) {
            this.initSliderByScreenSize(block);
          }
        });
      }

      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;

        for (const block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }

      if (
        MinimogTheme.config.mqlMobile &&
        this.mobileSliderDisable &&
        this.buttonType === "load"
      ) {
        this.canLoad = true;
        this.currentPage = 1;

        for (const block of this.domNodes.tabContent) {
          this.initLoadMore(block);
        }
      }

      document.addEventListener("matchMobile", () => {
        if (
          MinimogTheme.config.mqlMobile &&
          this.mobileSliderDisable &&
          this.buttonType === "load"
        ) {
          this.canLoad = true;
          this.currentPage = 1;

          for (const block of this.domNodes.tabContent) {
            this.initLoadMore(block);
          }
        }
      });

      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          const blockSelectedIsTab = event.target.classList.contains("m-tab-content");
          if (!blockSelectedIsTab) return;

          const dataIndex = event.target.dataset.index;
          this.tabs.setActiveTab(dataIndex);
        });
      }
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (target) => {
        const tabId = target.getAttribute("href");
        const tabContent = tabId ? this.querySelector(tabId) : null;

        if (!tabContent) return;

        window.setTimeout(() => {
          const swiperElement = tabContent.querySelector(
            ".m-mixed-layout__wrapper.swiper-container"
          );
          const swiper = swiperElement?.swiper;

          if (swiper) {
            swiper.allowTouchMove = true;
            swiper.params.allowTouchMove = true;
            swiper.params.simulateTouch = true;
            swiper.updateSize();
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            swiper.pagination?.render();
            swiper.pagination?.update();
            this.updateSliderState(tabContent, swiper);
          }

          this.updateNavigationOffset(tabContent);
        }, 60);
      });
    }

    initSliderByScreenSize(tabContent) {
      const swiperElement = tabContent.querySelector(".m-mixed-layout__wrapper");
      const navigationControls = tabContent.querySelector(
        ".m-product-tabs__navigation-controls"
      );
      const progressControls = tabContent.querySelector(
        ".m-product-tabs__progressbar-controls"
      );

      if (!swiperElement) return;

      if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable) {
        navigationControls?.classList.add("m:hidden");
        progressControls?.classList.add("m:hidden");

        if (swiperElement.swiper) {
          swiperElement.swiper.destroy(false, true);
        }

        swiperElement.classList.remove("swiper-container");
        this.tabSliders.delete(tabContent);
        return;
      }

      swiperElement.classList.add("swiper-container");

      window.setTimeout(() => {
        this.initSlider(tabContent);
      }, 30);
    }

    initSlider(tabContent) {
      const layoutWrapper = tabContent.querySelector(".m-product-list");
      const swiperElement = tabContent.querySelector(
        ".m-mixed-layout__wrapper"
      );
      const swiperWrapper = tabContent.querySelector(".swiper-wrapper");
      const navigationControls = tabContent.querySelector(
        ".m-product-tabs__navigation-controls"
      );
      const progressControls = tabContent.querySelector(
        ".m-product-tabs__progressbar-controls"
      );
      const prevButton = navigationControls?.querySelector(
        ".m-slider-controls__button-prev"
      );
      const nextButton = navigationControls?.querySelector(
        ".m-slider-controls__button-next"
      );
      const paginationElement = progressControls?.querySelector(
        ".swiper-pagination"
      );
      const slideItemsLength = swiperWrapper?.childElementCount || 0;

      if (!swiperElement || !swiperWrapper || slideItemsLength < 1) return;

      tabContent.dataset.realSlideCount = String(slideItemsLength);

      const existingSwiper = swiperElement.swiper;

      if (existingSwiper && !existingSwiper.destroyed) {
        existingSwiper.update();
        existingSwiper.pagination?.render();
        existingSwiper.pagination?.update();
        this.updateSliderState(tabContent, existingSwiper);
        return;
      }

      // Prevent the browser's native image/link drag from stealing the
      // horizontal mouse gesture from Swiper on desktop.
      if (!swiperElement.dataset.mouseDragReady) {
        swiperElement.dataset.mouseDragReady = "true";
        swiperElement.addEventListener("dragstart", (event) => {
          event.preventDefault();
        });
      }

      const shouldLoop = slideItemsLength > this.items;

      const swiper = new MinimogLibs.Swiper(swiperElement, {
        slidesPerView: this.mobileItems,
        loop: shouldLoop,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        resizeObserver: true,

        // Explicit desktop mouse-drag support.
        simulateTouch: true,
        allowTouchMove: true,
        grabCursor: true,
        touchEventsTarget: "container",
        touchStartPreventDefault: true,
        touchStartForcePreventDefault: false,
        touchMoveStopPropagation: false,
        preventClicks: true,
        preventClicksPropagation: true,
        preventInteractionOnTransition: false,
        noSwiping: false,
        threshold: 4,

        navigation:
          this.showNavigation && prevButton && nextButton
            ? {
                prevEl: prevButton,
                nextEl: nextButton,
              }
            : false,

        pagination:
          this.showPagination && paginationElement
            ? {
                el: paginationElement,
                type: this.paginationType,
                progressbarOpposite: false,
              }
            : false,

        breakpoints: {
          768: {
            slidesPerView: this.items >= 3 ? 3 : this.items,
          },
          992: {
            slidesPerView: this.items >= 4 ? 4 : this.items,
          },
          1280: {
            slidesPerView: this.items,
          },
        },

        on: {
          init: (instance) => {
            window.setTimeout(() => {
              this.updateNavigationOffset(tabContent);
              this.updateSliderState(tabContent, instance);
            }, 200);
          },
          breakpoint: (instance) => {
            instance.allowTouchMove = true;
            instance.params.allowTouchMove = true;
            window.setTimeout(() => {
              this.updateSliderState(tabContent, instance);
            }, 20);
          },
          resize: (instance) => {
            this.updateSliderState(tabContent, instance);
          },
          lock: (instance) => {
            this.updateSliderState(tabContent, instance);
          },
          unlock: (instance) => {
            this.updateSliderState(tabContent, instance);
          },
          slideChange: (instance) => {
            instance.pagination?.update();
          },
          loopFix: (instance) => {
            instance.pagination?.update();
          },
        },
      });

      this.tabSliders.set(tabContent, swiper);
      layoutWrapper?.classList.remove("m-mixed-layout--mobile-grid");
    }

    updateSliderState(tabContent, swiper) {
      if (!swiper || swiper.destroyed) return;

      const navigationControls = tabContent.querySelector(
        ".m-product-tabs__navigation-controls"
      );
      const progressControls = tabContent.querySelector(
        ".m-product-tabs__progressbar-controls"
      );
      const prevButton = navigationControls?.querySelector(
        ".m-slider-controls__button-prev"
      );
      const nextButton = navigationControls?.querySelector(
        ".m-slider-controls__button-next"
      );

      const slidesPerView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      const slideCount =
        parseInt(tabContent.dataset.realSlideCount, 10) ||
        tabContent.querySelectorAll(
          ".swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)"
        ).length ||
        0;
      const hasOverflow = slideCount > slidesPerView;

      swiper.allowTouchMove = hasOverflow;
      swiper.params.allowTouchMove = hasOverflow;
      swiper.params.simulateTouch = true;

      navigationControls?.classList.toggle(
        "m:hidden",
        !this.showNavigation || !hasOverflow
      );
      progressControls?.classList.toggle(
        "m:hidden",
        !this.showPagination || !hasOverflow
      );

      if (hasOverflow) {
        prevButton?.classList.remove("m:hidden");
        nextButton?.classList.remove("m:hidden");
      }

      swiper.pagination?.update();
    }

    updateNavigationOffset(tabContent) {
      const firstItem =
        tabContent.querySelector(".m-image") ||
        tabContent.querySelector(".m-placeholder-svg");
      const navigationControls = tabContent.querySelector(
        ".m-product-tabs__navigation-controls"
      );

      if (!firstItem || !navigationControls) return;

      navigationControls.style.setProperty(
        "--offset-top",
        `${parseInt(firstItem.clientHeight, 10) / 2}px`
      );
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      if (!this.select) return;

      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value, 10));

        window.setTimeout(() => {
          const tabContent = this.tabs?.currentTab;
          const swiperElement = tabContent?.querySelector(
            ".m-mixed-layout__wrapper.swiper-container"
          );
          const swiper = swiperElement?.swiper;

          if (swiper) {
            swiper.allowTouchMove = true;
            swiper.params.allowTouchMove = true;
            swiper.params.simulateTouch = true;
            swiper.update();
            swiper.pagination?.render();
            swiper.pagination?.update();
            this.updateSliderState(tabContent, swiper);
          }

          if (tabContent) {
            this.updateNavigationOffset(tabContent);
          }
        }, 60);
      });
    }

    initLoadMore(wrapper) {
      addEventDelegate({
        context: wrapper,
        selector: this.selectors.loadMoreBtn,
        handler: (e) => {
          e.preventDefault();
          this.handleLoadMore(wrapper);
        },
      });
    }

    handleLoadMore(wrapper) {
      const loadBtn = wrapper.querySelector(this.selectors.loadMoreBtn);
      const productsContainer = wrapper.querySelector(this.selectors.productsContainer);

      let currentPage = wrapper.dataset.page;
      currentPage = parseInt(currentPage);
      const totalPages = wrapper.dataset.totalPages;
      this.toggleLoading(loadBtn, true);

      const url = wrapper.dataset.url;
      const dataUrl = `${url}?page=${currentPage + 1}&section_id=${this.id}`;
      fetchCache(dataUrl).then((html) => {
        currentPage++;
        wrapper.dataset.page = currentPage;
        this.toggleLoading(loadBtn, false);
        const dom = generateDomFromString(html);
        const tabId = wrapper.getAttribute("id");
        const products = dom.querySelector(`#${tabId} ${this.selectors.productsContainer}`);

        if (products) {
          Array.from(products.childNodes).forEach((product) => productsContainer.appendChild(product));
        }

        if (currentPage >= parseInt(totalPages)) loadBtn && loadBtn.remove();
      });

      // Remove button focus
      loadBtn.blur();
    }

    toggleLoading(loadBtn, status) {
      if (!loadBtn) return;
      if (status) {
        loadBtn.classList.add("m-spinner-loading");
      } else {
        loadBtn.classList.remove("m-spinner-loading");
      }
    }

  }

  customElements.define("m-product-tabs", MProductTabs);
}
